import ReactTooltip from "react-tooltip";
import styled from "styled-components";

export const Container = styled.div`
  color: ${({ theme }) => theme.old.colors.gray[600]};
  margin: 0 5px;
  transition: 200ms;
  cursor: pointer;
  display: grid;
  place-items: center;

  :hover {
    color: ${({ theme }) => theme.old.colors.gray[450]};
  }
`

export const CustomTooltip = styled(ReactTooltip)`
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  padding: 20px !important;
  border-radius: 8px !important;
  max-width: 300px !important;
  opacity: 1 !important;
  cursor: default !important;
`